import { assertIsNotUndefined } from "common/utils/assertOfType";
import type { Material, ShaderMaterial } from "three";
import type { DesignMaterialParamsPreprocessed } from "./designMaterialTypes";
import { getHatchTextureMaterial } from "./hatchTextureMaterial";

/**
 * Gets a material to use with hatching. Caches the result in the userData.
 * @param material THREE material, must have the material parameters set in userData.
 * @returns THREE material for hatching.
 */
export function getHatchTextureMaterialFromThreeMaterial(material: Material, hatchThreshold: number): ShaderMaterial {
  const userData = material.userData;

  assertIsNotUndefined(userData.materialParams);
  const materialParams = userData.materialParams as DesignMaterialParamsPreprocessed;

  if (!userData.cachedhatchTextureMaterial) {
    userData.cachedhatchTextureMaterial = getHatchTextureMaterial(
      materialParams,
      hatchThreshold,
      userData.cachedlibraryHatchMaterial,
    );
  }

  return userData.cachedhatchTextureMaterial;
}
